export default __webpack_public_path__ + "a4600e0e492991db7bb0510cccec4407.svg";